import { DexieDataSetEvent } from '@/models/dexie/UnsyncedDexieDataSet';
import { DataSetEventStatusTypeEnums } from '@/enums/DataSetEventStatusTypeEnums';
import { DataSet } from '../dataset/DataSet';
import { DataSetSection } from '@/models/dataset/DataSetSection';
import { ApiIdentifers } from '../../config/index';
import { DataSetEventTypeEnums } from '@/enums/DataSetEventTypeEnums';
export interface IUnsyncedTableItem {
    id: number;
    series: string;
    number: string;
    customer: string;
    location: string;
    unit: string;
    datetime: string;
    icon: string;
    eventType: DataSetEventTypeEnums;
}

export class UnsyncedTableItem implements IUnsyncedTableItem {
    public id: number;
    public series: string;
    public number: string;
    public customer: string;
    public location: string;
    public unit: string;
    public datetime: string;
    public icon: string;
    public eventType: DataSetEventTypeEnums;

    constructor();
    // tslint:disable-next-line: unified-signatures
    constructor(obj: IUnsyncedTableItem);
    constructor(obj?: any) {
        this.id = obj && obj.id != null ? obj.id : -1;
        this.series = (obj && obj.series) || '';
        this.number = (obj && obj.number) || '';
        this.customer = (obj && obj.customer) || '';
        this.location = (obj && obj.location) || '';
        this.unit = (obj && obj.unit) || '';
        this.datetime = (obj && obj.datetime) || '';
        this.icon = (obj && obj.icon) || '';
        this.eventType = (obj && obj.eventType) || DataSetEventTypeEnums.UNKNOWN;
    }

    // tslint:disable-next-line: member-ordering
    public static fromUnsyncedDexieDataSet(unsyncedDataSet: DexieDataSetEvent, oldDataSet?: DataSet): UnsyncedTableItem {
        const generalSection = unsyncedDataSet.dataSet.sections.find((section) => section.identifier === ApiIdentifers.general);
        const costumerSection = unsyncedDataSet.dataSet.sections.find((section) => section.identifier === ApiIdentifers.customer);
        const unitSection = unsyncedDataSet.dataSet.sections.find((section) => section.identifier === ApiIdentifers.unit);

        const oldGeneralSection = oldDataSet ? oldDataSet.sections.find((section) => section.identifier === ApiIdentifers.general) : undefined;
        const oldCostumerSection = oldDataSet ? oldDataSet.sections.find((section) => section.identifier === ApiIdentifers.customer) : undefined;
        const oldUnitSection = oldDataSet ? oldDataSet.sections.find((section) => section.identifier === ApiIdentifers.unit) : undefined;

        return new UnsyncedTableItem({
            id: unsyncedDataSet.id || -1,
            series: this.getValue(ApiIdentifers.generalTestSeries, generalSection) || this.getValue(ApiIdentifers.generalTestSeries, oldGeneralSection) || '',
            number: this.getValue(ApiIdentifers.generalTestNumber, generalSection) || this.getValue(ApiIdentifers.generalTestNumber, oldGeneralSection) || '',
            customer: this.getValue(ApiIdentifers.customerName, costumerSection) || this.getValue(ApiIdentifers.customerName, oldCostumerSection) || '',
            location: this.getValue(ApiIdentifers.customerCountry, costumerSection) || this.getValue(ApiIdentifers.customerCountry, oldCostumerSection) || '',
            unit: this.getValue(ApiIdentifers.unitName, unitSection) || this.getValue(ApiIdentifers.unitName, oldUnitSection) || '',
            datetime: new Date(unsyncedDataSet.date)
                .toISOString()
                .substr(0, 16)
                .replace('T', ' '),
            icon: UnsyncedTableItem.getIcon(unsyncedDataSet.eventStatus),
            eventType: unsyncedDataSet.event,
        });
    }

    // tslint:disable-next-line: member-ordering
    public static getIcon(status?: DataSetEventStatusTypeEnums): string {
        let icon = 'mdi-cloud-sync';
        switch (status) {
            case DataSetEventStatusTypeEnums.OK:
                icon = 'mdi-cloud-check';
                break;
            case DataSetEventStatusTypeEnums.UNSYNCED:
                icon = 'mdi-cloud-sync';
                break;
            case DataSetEventStatusTypeEnums.ERROR_API:
                icon = 'mdi-cloud-alert';
                break;
            case DataSetEventStatusTypeEnums.ERROR_SYNC:
                icon = 'mdi-cloud-off';
                break;
            default:
                break;
        }
        return icon;
    }

    // tslint:disable-next-line: member-ordering
    public static getValue(identifier: string, section?: DataSetSection): any {
        if (section && section.fields && section.fields.find((field) => field.identifier === identifier)) {
            const dataField = section.fields.find((field) => field.identifier === identifier);
            if (dataField && dataField.valueBool !== undefined) {
                return dataField.valueBool;
            } else if (dataField && dataField.valueNumber !== undefined) {
                return dataField.valueNumber;
            } else if (dataField && dataField.valueString !== undefined) {
                return dataField.valueString;
            }
        }
        return undefined;
    }
}
